export enum ForwardExportResult {
    SUCCESS = 'SUCCESS',
    FILE_COULD_NOT_BE_GENERATED = 'FILE_COULD_NOT_BE_GENERATED',
    EMAIL_COULD_NOT_BE_SENT = 'EMAIL_COULD_NOT_BE_SENT',
    GENERAL_ERROR = 'GENERAL_ERROR'
}
